









































































































import Vue from 'vue';
import { mapState } from 'vuex';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxTooltip from '@/dex-shared/components/px-tooltip.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import Header from '@/components/Header.vue';

export default Vue.extend({
  components: {
    pxCard,
    Header,
    pxButton,
    pxTooltip,
    Loading,
    ArrowRightIcon,
    SquareEditOutlineIcon,
    PlusIcon,
  },

  data() {
    return {
      courseContext: { id: null },
      openedClassroomSelectorIndex: -1,
      loaded: false,
      currentCoursePage: 0,
      numberOfCoursesToShow: 200,
    };
  },

  computed: {
    ...mapState({
      allBoards: (state: any) => state.boards.boards,
      classrooms: (state: any) => state.classrooms.classrooms,
      courses: (state: any) => state.courses.courses,
    }),
    sortedClassrooms: function() {
      const collator = new Intl.Collator('pt-br', {
        numeric: true,
        sensitivity: 'base',
      });
      return this.classrooms
        .concat()
        .sort((a: any, b: any) => collator.compare(a.name, b.name));
    },
    boards: function() {
      let courseContext = this.courseContext;
      let allBoards = this.$store.state.boards.boards;
      if (courseContext || courseContext.id === null) {
        return allBoards;
      } else {
        return allBoards.filter((board: any) => {
          if (board.classroom) {
            return board.classroom.course.id === courseContext.id;
          } else {
            return !courseContext;
          }
        });
      }
    },
  },

  async mounted() {
    this.loaded = false;
    await this.$store.dispatch('PULL_BOARDS');
    this.loaded = true;
    this.$store.dispatch('PULL_CLASSROOMS');
    this.$store.dispatch('PULL_COURSES', {
      currentPage: this.currentCoursePage,
      numberOfCoursesToShow: this.numberOfCoursesToShow,
    });
  },

  methods: {
    boardHasClassrooms: function(board: any) {
      return board.classrooms && board.classrooms.length;
    },
    openClassroomSelector: function(index: number) {
      if (index == this.openedClassroomSelectorIndex) {
        this.openedClassroomSelectorIndex = -1;
      } else {
        this.openedClassroomSelectorIndex = index;
      }
    },
    addBoardsClassroom: async function(classroomId: number, boardId: number) {
      await this.$store.dispatch('ADD_BOARDS_CLASSROOM', {
        classroomId,
        boardId,
      });
      await this.$store.dispatch('PULL_BOARDS');
    },
    hasClassroomsAssociated: function(classrooms, classroomID) {
      if (classrooms) {
        return !!classrooms.find(c => c.id === classroomID);
      } else {
        return false;
      }
    },
    boardCourses: function(board): Array<Object> {
      return board.classrooms
        .filter(c => c && c.courseByCourseId)
        .reduce((acc, classroom) => {
          const course = classroom.courseByCourseId;
          const accCourse = acc[course.id] || {};
          const accCourseClassrooms = accCourse.classrooms || [];

          return {
            ...acc,
            [course.id]: {
              ...acc[course.id],
              id: course.id,
              name: course.name,
              classrooms: [...accCourseClassrooms, classroom],
            },
          };
        }, {});
    },

    // removeBoard: async function(boardId: number, index: number) {
    //   if (
    //     confirm(
    //       "Tem certeza que deseja deletar esse mural? Ela não poderá ser recuperada!"
    //     )
    //   ) {
    //     let response = await this.$store.dispatch("REMOVE_BOARD", boardId);
    //     if (response === true) {
    //       this.$store.commit("REMOVE_BOARD", index);
    //     } else {
    //       //TODO analyze the error
    //       console.log(response);
    //       alert("Esse mural não pode ser deletada!");
    //     }
    //   }
    // }
  },
});
